import {
  CandidateDetail,
  RankedCandidate,
  RecruitmentBenchmark,
  RecruitmentCandidate,
  RecruitmentDashboardData,
} from '../models/recruitment.models';

export const MOCK_BENCHMARKS: RecruitmentBenchmark[] = [
  {
    benchmarkId: 'product-strategy-lead',
    roleTitle: 'Product Strategy Lead',
    department: 'Product',
    description: 'Customer-led product strategy, structured problem solving, and cross-functional influence.',
    version: 3,
    status: 'READY',
    candidateCount: 24,
    evaluatedCount: 21,
    updatedAt: '2026-09-08T16:15:00Z',
    topTraits: ['Context insight', 'Pattern logic', 'Persuasive communication'],
  },
  {
    benchmarkId: 'growth-operations-manager',
    roleTitle: 'Growth Operations Manager',
    department: 'Operations',
    description: 'Analytical operator who can translate ambiguous signals into repeatable growth systems.',
    version: 2,
    status: 'READY',
    candidateCount: 24,
    evaluatedCount: 21,
    updatedAt: '2026-09-06T13:30:00Z',
    topTraits: ['Analytical quantification', 'Adaptive reasoning', 'Attention to detail'],
  },
  {
    benchmarkId: 'client-success-partner',
    roleTitle: 'Client Success Partner',
    department: 'Customer Success',
    description: 'Trusted client partner with strong communication, judgment, and emotional regulation.',
    version: 4,
    status: 'RECALCULATING',
    candidateCount: 24,
    evaluatedCount: 16,
    updatedAt: '2026-09-11T19:05:00Z',
    topTraits: ['Persuasive communication', 'Context insight', 'Emotional regulation'],
  },
];

export const MOCK_CANDIDATES: RecruitmentCandidate[] = [
  {
    userId: 'candidate-1001',
    firstName: 'Maya',
    lastName: 'Shah',
    email: 'maya.shah@example.com',
    location: 'New York, NY',
    currentTitle: 'Senior Product Analyst',
    joinedAt: '2026-09-10T14:20:00Z',
    assessmentAvailability: 'AVAILABLE',
    assessmentCompletedAt: '2026-09-09T18:45:00Z',
    resumeAvailable: true,
    bestFit: {
      benchmarkId: 'product-strategy-lead', roleTitle: 'Product Strategy Lead', matchScore: 96,
      matchPercentage: 100, requirementsMet: 3, totalRequirements: 3, averageShortfall: 4,
      maximumShortfall: 7, behavioralAlignment: 'ALIGNED', behavioralScore: 91, behavioralCutoff: 82,
    },
  },
  {
    userId: 'candidate-1002',
    firstName: 'Daniel',
    lastName: 'Kim',
    email: 'daniel.kim@example.com',
    location: 'Chicago, IL',
    currentTitle: 'Operations Associate',
    joinedAt: '2026-09-09T10:05:00Z',
    assessmentAvailability: 'AVAILABLE',
    assessmentCompletedAt: '2026-09-08T16:30:00Z',
    resumeAvailable: true,
    bestFit: {
      benchmarkId: 'growth-operations-manager', roleTitle: 'Growth Operations Manager', matchScore: 93,
      matchPercentage: 100, requirementsMet: 3, totalRequirements: 3, averageShortfall: 7,
      maximumShortfall: 9, behavioralAlignment: 'ALIGNED', behavioralScore: 87, behavioralCutoff: 80,
    },
  },
  {
    userId: 'candidate-1003',
    firstName: 'Elena',
    lastName: 'Rodriguez',
    email: 'elena.rodriguez@example.com',
    location: 'Austin, TX',
    currentTitle: 'Customer Experience Lead',
    joinedAt: '2026-09-08T12:40:00Z',
    assessmentAvailability: 'AVAILABLE',
    assessmentCompletedAt: '2026-09-07T20:10:00Z',
    resumeAvailable: false,
    bestFit: {
      benchmarkId: 'client-success-partner', roleTitle: 'Client Success Partner', matchScore: 91,
      matchPercentage: 67, requirementsMet: 2, totalRequirements: 3, averageShortfall: 9,
      maximumShortfall: 14, behavioralAlignment: 'REVIEW', behavioralScore: 76, behavioralCutoff: 82,
    },
  },
  {
    userId: 'candidate-1004',
    firstName: 'Noah',
    lastName: 'Williams',
    email: 'noah.williams@example.com',
    location: 'Boston, MA',
    currentTitle: 'Business Analyst',
    joinedAt: '2026-09-07T09:15:00Z',
    assessmentAvailability: 'AVAILABLE',
    assessmentCompletedAt: '2026-09-06T15:00:00Z',
    resumeAvailable: true,
    bestFit: {
      benchmarkId: 'product-strategy-lead', roleTitle: 'Product Strategy Lead', matchScore: 88,
      matchPercentage: 67, requirementsMet: 2, totalRequirements: 3, averageShortfall: 12,
      maximumShortfall: 18, behavioralAlignment: 'ALIGNED', behavioralScore: 85, behavioralCutoff: 82,
    },
  },
  {
    userId: 'candidate-1005',
    firstName: 'Priya',
    lastName: 'Patel',
    email: 'priya.patel@example.com',
    location: 'San Francisco, CA',
    currentTitle: 'Strategy Consultant',
    joinedAt: '2026-09-06T17:20:00Z',
    assessmentAvailability: 'AVAILABLE',
    assessmentCompletedAt: '2026-09-05T18:00:00Z',
    resumeAvailable: true,
    bestFit: {
      benchmarkId: 'product-strategy-lead', roleTitle: 'Product Strategy Lead', matchScore: 86,
      matchPercentage: 67, requirementsMet: 2, totalRequirements: 3, averageShortfall: 14,
      maximumShortfall: 20, behavioralAlignment: 'REVIEW', behavioralScore: 79, behavioralCutoff: 82,
    },
  },
  {
    userId: 'candidate-1006',
    firstName: 'Owen',
    lastName: 'Brooks',
    email: 'owen.brooks@example.com',
    location: 'Seattle, WA',
    currentTitle: 'Program Coordinator',
    joinedAt: '2026-09-05T11:30:00Z',
    assessmentAvailability: 'UNAVAILABLE',
    resumeAvailable: false,
  },
  {
    userId: 'candidate-1007',
    firstName: 'Aisha',
    lastName: 'Rahman',
    email: 'aisha.rahman@example.com',
    location: 'Jersey City, NJ',
    currentTitle: 'Marketing Analyst',
    joinedAt: '2026-09-04T15:10:00Z',
    assessmentAvailability: 'UNAVAILABLE',
    resumeAvailable: true,
  },
];

export const MOCK_RANKED_CANDIDATES: RankedCandidate[] = MOCK_CANDIDATES
  .filter((candidate) => candidate.assessmentAvailability === 'AVAILABLE')
  .map((candidate, index) => ({
    ...candidate,
    fit: candidate.bestFit!,
    decision: (['MOVE_AHEAD', 'UNREVIEWED', 'HOLD', 'UNREVIEWED', 'REJECTED'][index] || 'UNREVIEWED') as RankedCandidate['decision'],
    note: index === 0 ? 'Strong structured thinking and clear customer orientation.' : '',
  }));

export const MOCK_DASHBOARD: RecruitmentDashboardData = {
  organization: {
    orgId: 'org-northstar',
    name: 'Northstar Labs',
    recruiterName: 'Jordan Lee',
    recruiterEmail: 'jordan@northstarlabs.example',
  },
  summary: {
    totalCandidates: 24,
    assessedCandidates: 21,
    assessmentUnavailable: 3,
    moveAhead: 6,
    hold: 4,
    rejected: 2,
  },
  benchmarks: MOCK_BENCHMARKS,
  recentCandidates: MOCK_CANDIDATES.slice(0, 5),
  organizationLink: {
    inviteId: 'invite-northstar-main',
    url: `${window.location.origin}/join/northstar-demo`,
    expiresAt: '2026-10-12T23:59:59Z',
    joinCount: 24,
    revoked: false,
  },
};

export const mockCandidateDetail = (candidateId: string): CandidateDetail | undefined => {
  const candidate = MOCK_CANDIDATES.find((item) => item.userId === candidateId);
  if (!candidate) return undefined;

  return {
    ...candidate,
    phone: '+1 (212) 555-0198',
    summary: 'Cross-functional operator focused on turning customer and market signals into practical product decisions.',
    profileType: 'Balanced strategist',
    overallPercentile: candidate.assessmentAvailability === 'AVAILABLE' ? 88 : undefined,
    decision: MOCK_RANKED_CANDIDATES.find((item) => item.userId === candidateId)?.decision || 'UNREVIEWED',
    note: MOCK_RANKED_CANDIDATES.find((item) => item.userId === candidateId)?.note,
    fits: candidate.bestFit ? [
      candidate.bestFit,
      {
        benchmarkId: 'growth-operations-manager', roleTitle: 'Growth Operations Manager', matchScore: 84,
        matchPercentage: 67, requirementsMet: 2, totalRequirements: 3, averageShortfall: 16,
        maximumShortfall: 22, behavioralAlignment: 'ALIGNED', behavioralScore: 84, behavioralCutoff: 80,
      },
      {
        benchmarkId: 'client-success-partner', roleTitle: 'Client Success Partner', matchScore: 78,
        matchPercentage: 67, requirementsMet: 2, totalRequirements: 3, averageShortfall: 22,
        maximumShortfall: 29, behavioralAlignment: 'REVIEW', behavioralScore: 78, behavioralCutoff: 82,
      },
    ] : [],
    traitComparisons: candidate.bestFit ? [
      { trait: 'context-insight', displayName: 'Context insight', candidateScore: 94, requiredScore: 88, shortfall: 0, status: 'MET' },
      { trait: 'pattern-logic', displayName: 'Pattern logic', candidateScore: 91, requiredScore: 89, shortfall: 0, status: 'MET' },
      { trait: 'persuasive-communication', displayName: 'Persuasive communication', candidateScore: 86, requiredScore: 90, shortfall: 4, status: 'BELOW' },
    ] : [],
  };
};
